import { motion, animate, useMotionValue, useTransform } from "framer-motion";
import React, { useEffect, useState } from "react";
import './Highlight.css'

export default function Highlight(props) {
    const [countValue, setCountValue] = useState(0);
    const count = useMotionValue(0)
    const rounded = useTransform(count, latest => Math.round(latest));

    useEffect(() => {
        const controls = animate(count, parseInt(props.count, 10), { duration: 3 });

        return () => {
            controls.stop();
        };
    }, [props.count]); // Trigger animation when props.count changes

    useEffect(() => {
        const unsubscribe = rounded.onChange(value => {
            setCountValue(value);
        });

        return unsubscribe;
    }, [rounded]);


    return (
        <div className="highlight">

            <motion.h3 className="clr-purple-200 fw-bold">{rounded.current}+</motion.h3>
            <div className="highlight-subtitle">
                {props.subtitle}
            </div>
        </div>
    );
}
